import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e95fc1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center place-content-center h-full w-full z-5" }
const _hoisted_2 = { class: "dialog p-4 text-center" }
const _hoisted_3 = { class: "mb-4 text-xl font-medium" }
const _hoisted_4 = { class: "flex flex-col mt-2 space-y-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion_pop = _resolveDirective("motion-pop")!

  return (_openBlock(), _createElementBlock("div", {
    class: "absolute w-full bg-white bg-opacity-95 transition-opacity z-5",
    style: _normalizeStyle(_ctx.containerStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.t("shared.moveConversation")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.t("transferConversationModal.description")), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transferChannelOptions, (option) => {
            return (_openBlock(), _createBlock(_component_Button, {
              key: option.channel,
              kind: 'primary',
              onClick: _withModifiers(($event: any) => (_ctx.requestDestination(option)), ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(option.channelDescription), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ])
      ])), [
        [_directive_motion_pop]
      ])
    ])
  ], 4))
}